import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";

import cx from 'classnames';
import _ from 'lodash';
import {
  Row,
  Col,
  ListGroup,
  Button,
  Image
} from "react-bootstrap";

import styles from './integration.module.scss';
import { INTEGRATION_TYPES } from 'constants/integrationList';
import { fetchIntegrations } from 'actions/integrations/integrations';
import { FigmaIntegrationCard } from './figma';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';
import { createMixpanelEvent } from 'actions/mixpanel';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_INTEGRATIONS } from 'constants/mixpanelEvents';

export const IntegrationView = () => {
  const dispatch = useDispatch();

  let { path, url } = useRouteMatch();

  useEffect(() => {
    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_INTEGRATIONS)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))
    
    dispatch(fetchIntegrations());
  }, [])

  const activatedIntegratons = useSelector(state => _.get(state, 'integrations.activated.items', []));

  return (
    <div className={styles.integrationContent}>
      <div className={styles.headerSection}>
        <span className={styles.headerTitle}>Integrations</span>
        <span className={styles.description}>Empower your workflow on various levels with the right integrations.</span>
      </div>
      <div className={styles.layout}>
        {INTEGRATION_TYPES.filter(item => item.type !== 'figma').map((data, index) => (
          <IntegrationCard data={data} index={index} url={url} integrations={activatedIntegratons} />
        ))}
        {INTEGRATION_TYPES.filter(item => item.type == 'figma').map((data, index) => (
          <FigmaIntegrationCard data={data} index={4} />
        ))}
      </div>
    </div>
  )
}


export function IntegrationCard({ data, index, url, integrations }) {
  const history = useHistory();

  const activatedIntegration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type === data.type;
  });

  const activated = activatedIntegration != null;

  return (
    <div key={index} onClick={() => { history.push({ pathname: `${url}/${data.route}`, state: data }) }} className={cx(styles.integrationCard, { [styles.activated]: activated })}>
      <div className={styles.contentWrapper}>
        <div className={styles.logoContainer}>
          <Image src={data.icon} />
        </div>
        <h4 className={styles.name}>{data.title}</h4>
        <p className={styles.description}>{data.description}</p>
      </div>
      <div className={styles.actionContainer}>
        {activated && <Button variant='secondary' className={cx(styles.button, { [styles.activatedBtn]: activated })}>Activated</Button>}
        {!activated && <Button variant='secondary' className={styles.button}>Activate</Button>}
      </div>
    </div>
  )
}
